class AutocompleteStateLayer {
  constructor () {
    this.eventBus = window.theme.nosto.eventBus
    this.events = window.theme.autocomplete.events
    this.storageKey = window.theme.autocomplete.config.storageKey

    this.state = {
      activeTerm: '',
      categories: { hits: [] },
      fetching: false,
      keywords: JSON.parse(sessionStorage.getItem(this.storageKey))
        ?.keywords || { hits: [] },
      popularSearches: JSON.parse(sessionStorage.getItem(this.storageKey))
        ?.popularSearches || { hits: [] },
      products: { hits: [], total: 0 },
      recentSearches:
        JSON.parse(sessionStorage.getItem(this.storageKey))?.recentSearches ||
        [],
      redirect: '',
    }

    this.subscribeToEvents()

    if (!sessionStorage.getItem(this.storageKey)) {
      this.eventBus.publish(this.events.UI.QUERY_UPDATED, {
        query: '',
      })
    } else {
      this.broadcast()
    }
  }

  saveInitialResponseToSessionStorage (response) {
    const existing = JSON.parse(sessionStorage.getItem(this.storageKey)) || {}

    const dataToStore = {
      activeTerm: response.query || '',
      keywords: response.keywords.hits || [],
      products: response.products?.hits || [],
      categories: response.categories?.hits || [],
      popularSearches: response.popularSearches?.hits || [],
      recentSearches: existing.recentSearches ?? this.state.recentSearches,
    }

    try {
      sessionStorage.setItem(this.storageKey, JSON.stringify(dataToStore))
    } catch (error) {
      console.warn(
        'Failed to save initial search response to sessionStorage:',
        error,
      )
    }
  }

  subscribeToEvents () {
    this.eventBus.subscribe(
      this.events.UI.QUERY_UPDATED,
      this.onQueryUpdated.bind(this),
    )
    this.eventBus.subscribe(
      this.events.API.QUERY_FETCHED,
      this.onQueryFetched.bind(this),
    )
    this.eventBus.subscribe(
      this.events.API.FETCH_FAILED,
      this.onFetchFailed.bind(this),
    )
  }

  onQueryUpdated (data) {
    this.state.activeTerm = (data && data.query) || ''

    this.eventBus.publish(
      this.events.API.ACTIVE_TERM_UPDATED,
      this.state.activeTerm,
    )

    if (!this.state.activeTerm) {
      this.state.fetching = false
      this.state.products = { hits: [], total: 0 }
      this.state.categories = { hits: [] }
      this.broadcast()
    } else {
      this.state.fetching = true
      this.state.products = { hits: [], total: 0 }
      this.state.categories = { hits: [] }
    }
  }

  async onQueryFetched (response) {
    this.state.categories = response.categories?.hits || []
    this.state.fetching = false

    this.state.keywords =
      response.keywords?.hits?.length > 0
        ? response.keywords
        : this.state.keywords

    this.state.popularSearches = response.popularSearches?.hits || []

    if (response.redirect) {
      const redirectUrl = new URL(response.redirect)
      const pathname = redirectUrl.pathname.replace('/', '')

      this.state.redirect = `${window.location.origin}${window.routes.rootUrl}${pathname}`
    } else {
      this.state.redirect = ''
    }

    if (response.products?.hits.length > 0) {
      const products = response.products || { hits: [], total: 0 }
      products.hits = response.products?.hits
      this.state.products = products
    }

    this.broadcast()

    if (this.state.activeTerm === '') {
      this.saveInitialResponseToSessionStorage(response)
    }
  }

  onFetchFailed () {
    this.state.categories = { hits: [] }
    this.state.fetching = false
    this.state.keywords = { hits: [] }
    this.state.redirect = ''
    this.state.products = { hits: [], total: 0 }

    this.broadcast()
  }

  broadcast () {
    this.eventBus.publish(this.events.STATE.RESPONSE_UPDATED, this.state)
  }
}

window.theme.autocomplete.stateLayer = new AutocompleteStateLayer()
